(function () {
    angular
        .module("dashboard")
        .controller("OrderUpEnableAudioModalController", [
            "$scope",
            "$uibModalInstance",
            "callback",
            OrderEnableAudioModalController ]);

    function OrderEnableAudioModalController(
        $scope,
        $uibModalInstance,
        callback
    ) {
        $scope.enable = function () {
            callback();
            $uibModalInstance.close();
        }
    }
})();
